var FirmwareUpdateSpotController = (function () {
    function FirmwareUpdateSpotController($rootScope, $scope, apiLanguage, releaseNotesService, productContextService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.apiLanguage = apiLanguage;
        this.releaseNotesService = releaseNotesService;
        this.productContextService = productContextService;
    }
    FirmwareUpdateSpotController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.hasReleaseNotes = function () {
            return Array.isArray(_this.$scope.releaseNotes) && _this.$scope.releaseNotes.length > 0;
        };
        var hasApplicationWatcher = this.$scope.$watch('hasApplication', function () {
            _this.$rootScope.$broadcast('has-application', _this.$scope.hasApplication);
            hasApplicationWatcher();
        });
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                return;
            }
            _this.$scope.group = group;
            if (_this.$scope.releaseNotesPageUrl) {
                _this.releaseNotesService
                    .get(_this.$scope.releaseNotesPageUrl, _this.apiLanguage)
                    .then(function (releaseNotes) {
                    _this.$scope.releaseNotes = releaseNotes;
                    _this.$rootScope.$broadcast('release-notes', releaseNotes);
                });
            }
        });
    };
    FirmwareUpdateSpotController.$inject = [
        '$rootScope',
        '$scope',
        'apiLanguage',
        'releaseNotes',
        'productContextService',
    ];
    return FirmwareUpdateSpotController;
}());
export { FirmwareUpdateSpotController };
